@if (type$ | async; as type) {
  @if (type === settingsType.Text) {
    <hard-form-input
      [config]="{ title: 'base.value', name: 'value' }"
      [form]="form"
      [formControl]="form.get('value')"
    ></hard-form-input>
  }

  @if (type === settingsType.LongText) {
    <hard-form-text-area
      [config]="{ title: 'base.value', name: 'value' }"
      [form]="form"
      [formControl]="form.get('value')"
    ></hard-form-text-area>
  }

  @if (type === settingsType.Number) {
    <hard-form-number
      [config]="{ title: 'base.value', name: 'value' }"
      [form]="form"
      [formControl]="form.get('value')"
    ></hard-form-number>
  }

  @if (type === settingsType.Checkbox) {
    <hard-form-checkbox
      [config]="{
        name: 'value',
        title:
          (form.get('value').value ? 'turn.off' : 'turnOn') | hardTranslate,
      }"
      [form]="form"
      [formControl]="form.get('value')"
    ></hard-form-checkbox>
  }

  @if (type === settingsType.Timespan) {
    <hard-form-input
      [config]="{
        title: 'base.value',
        name: 'value',
        placeholder: 'setting.timeOffsetPlaceHolder',
        params: { mask: '00:00:00' },
      }"
      [form]="form"
      [formControl]="form.get('value')"
    ></hard-form-input>
  }

  @if (type === settingsType.Array) {
    <hard-form-control-label title="base.value"></hard-form-control-label>
    @for (item of arrayForm.controls; track item; let i = $index) {
      <div class="flex flex-row mb-3 w-full">
        <hard-form-input
          class="me-3 flex-grow"
          [config]="{ name: 'value' }"
          [form]="form"
          [formControl]="item"
          [last]="true"
        ></hard-form-input>
        <hard-button
          (click)="removeControl(i)"
          [classBtn]="'color-red'"
        >
          <span class="icon-trashcan"></span>
        </hard-button>
      </div>
    }

    <div class="mb-3">
      <hard-button
        (click)="addControl()"
        type="success"
      >
        <span class="mr-2 icon-plus"></span>
        <span>{{ "base.add" | hardTranslate }}</span>
      </hard-button>
    </div>
  }

  @if (type === settingsType.Json) {
    <hard-form-text-area
      [config]="{ title: 'base.value', name: 'value' }"
      [form]="form"
      [formControl]="form.get('value')"
    ></hard-form-text-area>
  }
} @else {
  <hard-form-input
    [config]="{ title: 'base.value', name: 'value' }"
    [form]="form"
    [formControl]="form.get('value')"
  ></hard-form-input>
}
